<template>
	<Layout>
		<PageHeader :title="page.title" :items="page.items" />

		<b-card>
			<b-form @submit="onSubmit" @reset="onReset">
				<!-- 角色名称 -->
				<b-form-group
					label="Role:"
					label-cols-lg="2"
					label-align-lg="right"
					label-for="role"
					label-class="requiredRow"
				>
					<b-form-input
						id="role"
						v-model="form.roleName"
						placeholder="Please enter"
						required
						oninvalid="setCustomValidity('Please enter');"
						oninput="setCustomValidity('')"
					></b-form-input>
				</b-form-group>

				<!-- 备注 -->
				<b-form-group
					label="Remark:"
					label-cols-lg="2"
					label-align-lg="right"
					label-for="remark"
				>
					<b-form-textarea
						id="remark"
						v-model="form.remarks"
						placeholder="Enter Notes"
						rows="3"
						max-rows="6"
					></b-form-textarea>
				</b-form-group>

				<!-- 权限设置 -->
				<b-tabs pills>
					<b-tab title="Brand Function permission Settings" active>
						<b-card-text>
							<b-table :items="form.navMenuList" :fields="fields">
								<template v-slot:cell(module)="data">
									<b-form-checkbox
										v-model="data.item.allSelected"
										:indeterminate="data.item.indeterminate"
										aria-describedby="permissions"
										aria-controls="permissions"
										@change="
											chooseAll(
												!data.item.allSelected,
												data.item
											)
										"
									>
										<div>{{ data.item.title }}</div>
									</b-form-checkbox>
								</template>
								<template v-slot:cell(page)="data">
									<div
										v-for="i in data.item.children"
										:key="i.id"
									>
										<!-- v-if="i.children" -->
										<b-form-checkbox
											v-model="i.allSelected"
											:indeterminate="i.indeterminate"
											aria-describedby="permissions"
											aria-controls="permissions"
											@change="
												toggleAll(
													!i.allSelected,
													i,
													data.item
												)
											"
											@change.native="
												disabledButton(
													i.selected,
													i.children,
													i,
													data.item
												)
											"
										>
											<!-- {{ i.allSelected ? "Un-select All" : "Select All" }} -->
											{{ i.title }}
										</b-form-checkbox>
									</div>
								</template>
								<template v-slot:cell(permissions)="data">
									<div
										v-for="i in data.item.children"
										:key="i.id"
									>
										<div v-if="!i.children">
											<br />
										</div>
										<b-form-checkbox-group
											v-model="i.selected"
											:options="i.children"
											class="ml-4"
											value-field="id"
											text-field="title"
											:disabled="i.disabled"
											@change.native="
												disabledButton(
													i.selected,
													i.children,
													i,
													data.item
												)
											"
										></b-form-checkbox-group>
										<!-- @input="changeSelected(i.selected, i, data.item)" -->
									</div>
								</template>
							</b-table>
						</b-card-text>
					</b-tab>
					<b-tab title="Data permission Settings">
						<b-card-text>
							<b-table
								:items="form.roleDataPermission"
								:fields="roleDatafields"
							>
								<!-- <template v-slot:cell(module)="data">
                  <div>{{ data.item.title }}</div>
                </template>-->
								<template v-slot:cell(module)="data">
									<b-form-checkbox
										v-model="data.item.allSelected"
										:indeterminate="data.item.indeterminate"
										aria-describedby="permissions"
										aria-controls="permissions"
										@change="
											toggleAll(
												!data.item.allSelected,
												data.item
											)
										"
										>{{ data.item.name }}</b-form-checkbox
									>
									<!-- </div> -->
								</template>
								<template v-slot:cell(permissions)="data">
									<b-form-checkbox-group
										:id="data.item.id"
										v-model="data.item.dictionaryId"
										:options="data.item.dictionariesData"
										class="ml-4"
										value-field="id"
										text-field="name"
										@change.native="
											changeSelected(
												data.item.dictionaryId,
												data.item
											)
										"
									></b-form-checkbox-group>
								</template>
							</b-table>
						</b-card-text>
					</b-tab>
					<b-tab title="App Function Permission Setting">
						<b-card-text>
							<b-table
								:items="form.appNavMenuList"
								:fields="fields"
								caption-top
							>
								<template v-slot:cell(module)="data">
									<b-form-checkbox
										v-model="data.item.allSelected"
										:indeterminate="data.item.indeterminate"
										aria-describedby="permissions"
										aria-controls="permissions"
										@change="
											chooseAll(
												!data.item.allSelected,
												data.item
											)
										"
									>
										<div>{{ data.item.title }}</div>
									</b-form-checkbox>
								</template>
								<template v-slot:cell(page)="data">
									<div
										v-for="i in data.item.children"
										:key="i.id"
									>
										<!-- v-if="i.children" -->
										<b-form-checkbox
											v-model="i.allSelected"
											:indeterminate="i.indeterminate"
											aria-describedby="permissions"
											aria-controls="permissions"
											@change="
												toggleAll(
													!i.allSelected,
													i,
													data.item
												)
											"
											@change.native="
												disabledButton(
													i.selected,
													i.children,
													i,
													data.item
												)
											"
										>
											<!-- {{ i.allSelected ? "Un-select All" : "Select All" }} -->
											{{ i.title }}
										</b-form-checkbox>
									</div>
								</template>
								<template v-slot:cell(permissions)="data">
									<div
										v-for="i in data.item.children"
										:key="i.id"
									>
										<div v-if="!i.children"><br /></div>
										<b-form-checkbox-group
											v-model="i.selected"
											:options="i.children"
											class="ml-4"
											value-field="id"
											text-field="title"
											:disabled="i.disabled"
											@change.native="
												disabledButton(
													i.selected,
													i.children,
													i,
													data.item
												)
											"
										></b-form-checkbox-group>
									</div>
								</template>
							</b-table>
						</b-card-text>
					</b-tab>
				</b-tabs>
				<b-form-group label-cols-lg="2">
					<b-button type="submit" variant="primary">Confirm</b-button>
					<b-button type="reset" variant="danger" class="m-l-5 ml-1"
						>Cancel</b-button
					>
				</b-form-group>
			</b-form>
		</b-card>
	</Layout>
</template>
<script>
import Layout from '../../../layouts/main'
import PageHeader from '@/components/page-header'

import CKEditor from '@ckeditor/ckeditor5-vue'
import ClassicEditor from '@ckeditor/ckeditor5-build-classic'
import Multiselect from 'vue-multiselect'
/**
 * FAQ Add component
 */
export default {
	components: {
		Layout,
		PageHeader,
		ckeditor: CKEditor.component,
		Multiselect,
	},
	data() {
		return {
			page: {
				title: this.editId ? 'Role Modify' : 'Role Create',
				items: [
					{
						text: 'UNI-CORE',
						// href: "/"
					},
					{
						text: 'Account Mgmt',
						// href: "/"
					},
					{
						text: this.editId ? 'Role Modify' : 'Role Create',
						active: true,
					},
				],
			},
			fields: [
				{ key: 'module', label: 'Module' },
				{ key: 'page', label: 'Page' },
				{
					key: 'permissions',
					label: 'Operating authorization',
				},
			],
			roleDatafields: [
				{ key: 'module', label: 'Module' },
				{
					key: 'permissions',
					label: 'Data Permission',
				},
			],
			form: {
				roleName: '',
				remarks: '',
				navMenuList: [],
				menuId: [],
				appNavMenuList: [], //APP功能权限列表
				appMenuId: [],
				roleDataPermission: [],
			},
			editor: ClassicEditor,
			editId: window.location.search,
			photoName: '',
			roleDataPermission: [],
		}
	},
	beforeCreate() {
		this.editId = window.location.search
	},
	created() {
		if (this.editId) {
			let id = this.editId.split('=')[1]
			this.formData(id)
		} else {
			this.$api.customerManage.findAllMenu().then((res) => {
				if (res.success) {
					// res.data.forEach((element) => {
					// 	if (element.title === 'Home') {
					// 		element.allSelected = true
					// 	}
					// })
					this.form.navMenuList = res.data
				} else {
					if (res.message) {
						this.$bvToast.toast(res.message)
					}
				}
			})
			this.$api.customerManage
				.selectDeveloperMenu()
				.then((res) => {
					if (res.success) {
						this.form.appNavMenuList = res.data
					}
				})
				.catch((error) => {
					this.$toast(error)
				})
			this.$api.customerManage.selectAllDataPermission().then((res) => {
				if (res.success) {
					this.form.roleDataPermission = res.data
					if (this.roleDataPermission) {
						for (
							let index = 0;
							index < this.roleDataPermission.length;
							index++
						) {
							const element = this.roleDataPermission[index]
							for (
								let i = 0;
								i < this.form.roleDataPermission.length;
								i++
							) {
								const ele = this.form.roleDataPermission[i]
								if (
									element.dictionaryType ==
										ele.dictionaryType &&
									element.dictionaryId
								) {
									ele.dictionaryId = element.dictionaryId
									this.changeSelected(ele.dictionaryId, ele)
								}
							}
						}
					}
				} else {
					if (res.message) {
						this.$bvToast.toast(res.message)
					}
				}
			})
		}
	},
	mounted() {},
	methods: {
		init() {
			this.$api.customerManage.selectAllDataPermission().then((res) => {
				if (res.success) {
					this.form.roleDataPermission = res.data
					if (this.roleDataPermission) {
						for (
							let index = 0;
							index < this.roleDataPermission.length;
							index++
						) {
							const element = this.roleDataPermission[index]
							for (
								let i = 0;
								i < this.form.roleDataPermission.length;
								i++
							) {
								const ele = this.form.roleDataPermission[i]
								if (
									element.dictionaryType ==
										ele.dictionaryType &&
									element.dictionaryId
								) {
									ele.dictionaryId = element.dictionaryId
									this.changeSelected(ele.dictionaryId, ele)
								}
							}
						}
					}
				} else {
					if (res.message) {
						this.$bvToast.toast(res.message)
					}
				}
			})
		},
		init2() {
			this.$api.Dropdown.brandList().then((res) => {
				if (res.success) {
					let brandList = res.data.map((item) => {
						return { id: item.id, name: item.brandName }
					})
					let dictionaryType = true
					this.form.roleDataPermission.forEach((item) => {
						if (item.dictionaryType == 2) {
							this.$set(item, 'children', brandList)
							this.$set(item, 'title', 'Brand')
							dictionaryType = false
						}
					})
					if (dictionaryType) {
						this.form.roleDataPermission.push({
							dictionaryType: 2,
							dictionaryId: [],
							title: 'Brand',
							children: brandList,
						})
					}
					this.init3()
				} else {
					if (res.message) {
						this.$bvToast.toast(res.message)
					}
				}
			})
		},
		init3() {
			this.$api.Dropdown.manufacturerEncodingList().then((res) => {
				if (res.success) {
					let manufacturerEncodingList = res.data.map((item) => {
						return { id: item.id, name: item.name }
					})
					let dictionaryType = true
					this.form.roleDataPermission.forEach((item) => {
						if (item.dictionaryType == 3) {
							this.$set(
								item,
								'children',
								manufacturerEncodingList
							)
							this.$set(item, 'title', 'Manufacturer')
							dictionaryType = false
						}
						this.changeSelected(item.dictionaryId, item)
					})
					if (dictionaryType) {
						this.form.roleDataPermission.push({
							dictionaryType: 3,
							dictionaryId: [],
							title: 'Manufacturer',
							children: manufacturerEncodingList,
						})
					}
				} else {
					if (res.message) {
						this.$bvToast.toast(res.message)
					}
				}
			})
		},
		onSubmit(evt) {
			evt.preventDefault()
			this.$set(this.form, 'menuId', [])
			this.form.navMenuList.forEach((item) => {
				if (item.allSelected || item.indeterminate) {
					this.form.menuId.push(item.id)
				}
				if (item.children) {
					item.children.forEach((ele) => {
						if (ele.allSelected || ele.indeterminate) {
							this.form.menuId.push(ele.id)
						}
						if (
							ele.children &&
							ele.selected &&
							ele.selected.length > 0
						) {
							this.form.menuId = this.form.menuId.concat(
								ele.selected
							)
						}
					})
				}
			})
			this.$set(this.form, 'appMenuId', [])
			console.log(this.form.appNavMenuList)
			let confirmFail = false
			this.form.appNavMenuList.forEach((item) => {
				//#region 特殊处理（APP指定菜单只能选两个）
				if (item.menuAlias == 'brandWaveAdjuster') {
					if (item.children.length > 0 && item.children[0].selected) {
						if (
							item.allSelected ||
							item.children[0].selected.length > 2
						) {
							confirmFail = true
							return
						}
					}
				}
				//#endregion
				if (item.allSelected || item.indeterminate) {
					this.form.appMenuId.push(item.id)
				}
				if (item.children) {
					item.children.forEach((ele) => {
						if (ele.allSelected || ele.indeterminate) {
							this.form.appMenuId.push(ele.id)
						}
						if (
							ele.children &&
							ele.selected &&
							ele.selected.length > 0
						) {
							this.form.appMenuId = this.form.appMenuId.concat(
								ele.selected
							)
						}
					})
				}
			})
			this.form.roleDataPermission = this.form.roleDataPermission.map(
				(item) => {
					return {
						dictionaryId: item.dictionaryId,
						dictionaryType: item.dictionaryType,
					}
				}
			)
			if (confirmFail) {
				this.$toastWarning(
					'App function permission only two submenus can be selected'
				)
				return
			}
			if (this.form.id) {
				let updateSupplierRoleVo = this.form
				delete updateSupplierRoleVo.navMenuList
				delete updateSupplierRoleVo.appNavMenuList
				this.$api.customerManage
					.roleUpdateById(updateSupplierRoleVo)
					.then((res) => {
						if (res.success) {
							this.$router.go(-1)
						} else {
							if (res.message) {
								this.$bvToast.toast(res.message)
							}
						}
					})
			} else {
				let addSupplierRoleVo = this.form
				delete addSupplierRoleVo.navMenuList
				delete addSupplierRoleVo.appNavMenuList
				this.$api.customerManage
					.roleAdd(addSupplierRoleVo)
					.then((res) => {
						if (res.success) {
							this.$router.go(-1)
						} else {
							if (res.message) {
								this.$bvToast.toast(res.message)
							}
						}
					})
			}
		},
		onReset(evt) {
			evt.preventDefault()
			this.form = {
				roleName: '',
				remarks: '',
				navMenuList: [],
				menuId: [],
				appNavMenuList: [],
				appMenuId: [],
				roleDataPermission: [],
			}
			this.$nextTick(() => {
				this.$router.go(-1)
			})
		},
		formData(id) {
			this.$api.customerManage.roleFindById({ id: id }).then((res) => {
				if (res.success) {
					this.form = res.data
					this.roleDataPermission = res.data.roleDataPermission
					this.form.navMenuList.forEach((item) => {
						if (item.isSelected == 1 && !item.children) {
							this.$set(item, 'allSelected', true)
						}
						if (item.isSelected == 1 && item.children) {
							item.children.forEach((ele) => {
								if (ele.isSelected == 1 && !ele.children) {
									this.$set(ele, 'allSelected', true)
									this.toggleAll(!ele.allSelected, ele, item)
								} else if (
									ele.isSelected == 1 &&
									ele.children
								) {
									this.$set(ele, 'selected', [])
									ele.children.forEach((a) => {
										if (a.isSelected == 1) {
											ele.selected.push(a.id)
											this.changeSelected(
												ele.selected,
												ele,
												item
											)
										}
									})
								}
							})
						}
					})
					this.form.appNavMenuList.forEach((item) => {
						if (item.isSelected == 1 && !item.children) {
							this.$set(item, 'allSelected', true)
						}
						if (item.isSelected == 1 && item.children) {
							item.children.forEach((ele) => {
								if (ele.isSelected == 1 && !ele.children) {
									this.$set(ele, 'allSelected', true)
									this.toggleAll(!ele.allSelected, ele, item)
								} else if (
									ele.isSelected == 1 &&
									ele.children
								) {
									this.$set(ele, 'selected', [])
									ele.children.forEach((a) => {
										if (a.isSelected == 1) {
											ele.selected.push(a.id)
											this.changeSelected(
												ele.selected,
												ele,
												item
											)
										}
									})
								}
							})
						}
					})
					this.init()
				} else {
					if (res.message) {
						this.$bvToast.toast(res.message)
					}
				}
			})
		},
		chooseAll(checked, item) {
			if (checked && item.children) {
				item.children.forEach((i) => {
					this.$set(i, 'allSelected', true)
					this.toggleAll(i.allSelected, i, item)
				})
				this.$set(item, 'indeterminate', false)
				this.$set(item, 'allSelected', true)
			} else if (checked && !item.children) {
				this.$set(item, 'indeterminate', false)
				this.$set(item, 'allSelected', true)
			} else {
				if (item.children) {
					item.children.forEach((i) => {
						this.$set(i, 'allSelected', false)
						this.toggleAll(i.allSelected, i, item)
					})
				}
				this.$set(item, 'indeterminate', false)
				this.$set(item, 'allSelected', false)
			}
		},
		toggleAll(checked, item, par) {
			if (checked && item.children) {
				item.selected = item.children.map((item) => {
					return item.id
				})
				this.$set(item, 'indeterminate', false)
				this.$set(item, 'allSelected', true)
			} else if (checked && !item.children) {
				this.$set(item, 'indeterminate', false)
				this.$set(item, 'allSelected', true)
			} else {
				item.selected = []
				this.$set(item, 'indeterminate', false)
				this.$set(item, 'allSelected', false)
			}
			if (checked && item.dictionariesData) {
				item.selected = item.dictionariesData.map((item) => {
					return item.id
				})
				if (item.dictionaryId) {
					item.dictionaryId = item.dictionariesData.map((item) => {
						return item.id
					})
				}
				this.$set(item, 'indeterminate', false)
				this.$set(item, 'allSelected', true)
			} else if (checked && !item.dictionariesData) {
				this.$set(item, 'indeterminate', false)
				this.$set(item, 'allSelected', true)
			} else {
				item.selected = []
				item.dictionaryId = []
				this.$set(item, 'indeterminate', false)
				this.$set(item, 'allSelected', false)
			}
			this.isAll(par)
		},
		isAll(par) {
			let a = 0
			let b = 0
			if (par) {
				par.children.forEach((i) => {
					if (i.allSelected) {
						a++
					}
					if (i.indeterminate) {
						b++
					}
				})
				if (a == par.children.length && b === 0) {
					this.$set(par, 'indeterminate', false)
					this.$set(par, 'allSelected', true)
				} else if (a === 0 && b === 0) {
					this.$set(par, 'indeterminate', false)
					this.$set(par, 'allSelected', false)
				} else {
					this.$set(par, 'indeterminate', true)
					this.$set(par, 'allSelected', false)
				}
			}
		},
		changeSelected(selected, item, par) {
			if (!selected || selected.length === 0) {
				this.$set(item, 'indeterminate', false)
				this.$set(item, 'allSelected', false)
			} else if (
				selected &&
				item.children &&
				item.children.length == selected.length
			) {
				this.$set(item, 'indeterminate', false)
				this.$set(item, 'allSelected', true)
			} else if (
				selected &&
				item.dictionariesData &&
				item.dictionariesData.length == selected.length
			) {
				this.$set(item, 'indeterminate', false)
				this.$set(item, 'allSelected', true)
			} else {
				this.$set(item, 'indeterminate', true)
				this.$set(item, 'allSelected', false)
			}
			this.isAll(par)
		},
		disabledButton(selected, children, i, par) {
			if (selected && children) {
				this.$set(i, 'disabled', true)
				if (selected.indexOf(children[0].id) == -1) {
					selected = []
					this.$set(i, 'selected', [])
				} else {
					this.$set(i, 'disabled', false)
				}
				if (!selected || selected.length === 0) {
					this.$set(i, 'indeterminate', false)
					this.$set(i, 'allSelected', false)
					this.$set(i, 'disabled', false)
				} else if (selected && i.children.length == selected.length) {
					this.$set(i, 'indeterminate', false)
					this.$set(i, 'allSelected', true)
					this.$set(i, 'disabled', false)
				} else {
					this.$set(i, 'indeterminate', true)
					this.$set(i, 'allSelected', false)
					this.$set(i, 'disabled', false)
				}
				this.isAll(par)
			}
		},
	},
}
</script>
